module.exports = __webpack_public_path__ + "static/imagen_05-7a3744132d0c337aefbece8150cc283f.jpg";